import React from 'react';
import UnknownErrorContent from './UnknownErrorContent';
import { SOCKET_ERROR } from '../../../utils/socket/socketConstants';
import SocketActionErrorContent from './SocketActionErrorContent';
import SocketConnectionErrorContent from './SocketConnectionErrorContent';
import SocketActionLimitExceededErrorContent from './SocketActionLimitExceededErrorContent';
import { ATTACHMENT_ERROR, BOARD_ERROR, USER_ERROR } from '../../../../common/error/errorConstants';
import BoardSimpleErrorContent from './BoardSimpleErrorContent';
import BoardAccessDeniedErrorContent from './BoardAccessDeniedErrorContent';
import TimeoutErrorContent from './TimeoutErrorContent';
import FreeFileLimitErrorContent from './FreeFileLimitErrorContent';
import AttachmentErrorContent from './AttachmentErrorContent';
import AppInitialisationErrorContent from './AppInitialisationErrorContent';
import CanvasSizeErrorContent from './CanvasSizeErrorContent';

export type ErrorNoticeContent = {
    component: React.FC<any>;
    withoutModalOverlay?: boolean;
    preventModalClose?: boolean;
};

const ERROR_CONTENT_MAP: { [key: string]: ErrorNoticeContent } = {
    // Unknown error
    default: {
        component: UnknownErrorContent,
    },
    [SOCKET_ERROR.ACTION_FAILURE]: {
        component: SocketActionErrorContent,
        withoutModalOverlay: true,
    },
    [SOCKET_ERROR.CONNECTION_FAILURE]: {
        component: SocketConnectionErrorContent,
        preventModalClose: true,
        withoutModalOverlay: true,
    },
    [SOCKET_ERROR.ACTION_LIMIT_EXCEEDED]: {
        component: SocketActionLimitExceededErrorContent,
        preventModalClose: true,
        withoutModalOverlay: true,
    },
    [BOARD_ERROR.GENERIC_ERROR]: {
        component: UnknownErrorContent,
    },
    // Deleted or doesn't exist
    [BOARD_ERROR.DELETED]: {
        component: BoardSimpleErrorContent,
    },
    [BOARD_ERROR.NOT_FOUND]: {
        component: BoardSimpleErrorContent,
    },
    // Access
    // FIXME Where should this constant live?  Is it a HTTP constant?
    credentials_required: {
        component: BoardAccessDeniedErrorContent,
    },
    [BOARD_ERROR.ACCESS_DENIED]: {
        component: BoardAccessDeniedErrorContent,
    },
    // Timeouts
    [BOARD_ERROR.TIMEOUT]: {
        component: TimeoutErrorContent,
    },
    [BOARD_ERROR.CONNECTION_LOST]: {
        component: TimeoutErrorContent,
    },
    [ATTACHMENT_ERROR.FREE_FILE_COUNT_LIMIT]: {
        component: FreeFileLimitErrorContent,
    },
    [ATTACHMENT_ERROR.GENERAL_ERROR]: {
        component: AttachmentErrorContent,
    },
    [USER_ERROR.APP_INIT_ERROR]: {
        component: AppInitialisationErrorContent,
    },
    [BOARD_ERROR.CANVAS_SIZE]: {
        component: CanvasSizeErrorContent,
    },
};

const getErrorNoticeContent = (activeErrorNoticeId: string | undefined): ErrorNoticeContent | undefined => {
    if (!activeErrorNoticeId) return;

    return ERROR_CONTENT_MAP[activeErrorNoticeId] || ERROR_CONTENT_MAP.default;
};

export default getErrorNoticeContent;
